module.exports = __webpack_public_path__ + "img/p4wa.512ca3a9.jpeg";